import { Injectable } from '@angular/core';
import { CanDeactivate} from '@angular/router';
import {ComponentCanDeactivate} from './component-can-deactivate';
import { TranslateService } from '@ngx-translate/core';
import { AuthClient } from '../../../auth/auth.client';
import { Observable } from 'rxjs';

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {
  private reloadMessage: string;
  constructor(private _translateService: TranslateService, private _authClient: AuthClient){
    this._translateService.get('DEPLOYMENT.RELOAD').subscribe((message: string) => {
      this.reloadMessage = message;
    });
  }
  canDeactivate(component: ComponentCanDeactivate) {
    return this._authClient.isAuthenticatedAsync().map(e => {
      if (e) {
        if(!component.canDeactivate()){
          return confirm(this.reloadMessage)
        }
      }
      return true;
    }).catch(() => {
      return Observable.of(false);
    });
  }
}
